import { BiPencil, BiTrashAlt } from "react-icons/bi";
import { Button } from "../../../components/ui/button";
import { PaddedIcon } from "../../../components/ui/button/Icon";
import Workspace from "../../../components/workspace";
import { useFeatureFlag } from "../../../state/featureFlagContext";

const Permission = ({ permission, formModal, setSelected }) => {
   const { allowPermissionMaintenance } = useFeatureFlag();

   return (
      <Workspace.ItemWrapper
         onClick={() => {
            setSelected(permission);
            formModal.onOpen();
         }}>
         <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />
            <div className="grid gap-x-3 grid-cols-12 w-full items-center">
               <p className="col-span-8 font-bold overflow-hidden overflow-ellipsis" title="Permission name">
                  {permission.name}
               </p>

               <div className="col-span-4">{permission.description}</div>

               {allowPermissionMaintenance ? (
                  <div className="flex justify-end flex-wrap w-1/12 md:w-3/12 ms-4">
                     <PaddedIcon variant="primary" title="Edit" aria-label="Edit">
                        <BiPencil className="text-lg" />
                     </PaddedIcon>
                     <Button
                        variant="danger"
                        onClick={(e) => {
                           e.stopPropagation();
                        }}>
                        <BiTrashAlt />
                     </Button>
                  </div>
               ) : null}
            </div>
         </div>
      </Workspace.ItemWrapper>
   );
};

export default Permission;
